// #region Imports

import { Header, Icon, type SemanticWIDTHS, Table, Tooltip } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import { ModeReglementContext } from '@/contexts';
import type { DataReglementType } from '@/types';
import { formatMonetaire } from '@/utils';

// #endregion

// #region Types

interface ModalAffectationReglementTableHeaderProps {
  reglements: DataReglementType[];
}

// #endregion

const ModalAffectationReglementTableHeader = (props: ModalAffectationReglementTableHeaderProps) => {
  const { reglements } = props;

  const { regieModesReglement } = React.useContext(ModeReglementContext);

  return (
    <Table.Header
      style={{
        position: 'sticky',
        top: -1,
        background: 'white',
        zIndex: 10,
      }}
    >
      <Table.Row>
        <Table.HeaderCell style={{ width: '12%' }}>N° de facture</Table.HeaderCell>
        <Table.HeaderCell style={{ width: '5%' }}>Date limite</Table.HeaderCell>
        <Table.HeaderCell width={(6 - _.size(reglements) * 2) as SemanticWIDTHS}>
          Produits et montants
        </Table.HeaderCell>
        <Table.HeaderCell width={2} textAlign="right">
          Total facture
        </Table.HeaderCell>
        <Table.HeaderCell width={2} textAlign="right">
          Montant à encaisser
        </Table.HeaderCell>
        {_.map(reglements, (r, indice) => {
          const nomReglement =
            _.find(regieModesReglement, { identifiant: r.identifiantModeReglement })?.libelle ?? '';

          return (
            <Table.Cell
              warning
              textAlign="right"
              style={{ borderBottom: '1px solid rgba(152,162,179,.2)' }}
              title="Veuillez renseigner les montants"
              width={2}
            >
              {indice === 0 && (
                <Tooltip
                  mouseEnterDelay={100}
                  // @ts-expect-error
                  flowing
                  type="warning"
                  trigger={
                    <Icon name="Info" iconSet="Lucide" size={22} style={{ float: 'left' }} />
                  }
                  message={
                    <div>
                      <Header as="h5">Astuce :</Header>
                      <div style={{ maxWidth: 350 }}>
                        La touche + de votre pavé numérique permet d&apos;affecter automatiquement
                        le reste à répartir du règlement au produit sélectionné.
                      </div>
                    </div>
                  }
                  position="bottom center"
                />
              )}
              <b>{nomReglement}</b>
              <br />
              <b>{formatMonetaire(r.montant)}</b>
            </Table.Cell>
          );
        })}
        <Table.HeaderCell width={2} textAlign="right">
          Reste à encaisser
        </Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  );
};

export default ModalAffectationReglementTableHeader;
